import React from 'react';
import { ReactComponent as Expand } from '../../../assets/img/icons/common/Expand.svg';
import { ReactComponent as Close } from '../../../assets/img/icons/common/Close.svg';
import { useFullscreenContext } from './FullscreenContext';

export const FullscreenButton = ({ size = 24 }) => {
  const { provided, fullscreen, setFullscreenOpen } = useFullscreenContext();

  if (!provided) return null;

  return fullscreen ? (
    <button className="p-2" onClick={() => setFullscreenOpen(false)}>
      <Close role="button" width={size} height={size} color="#1A1A1A" />
    </button>
  ) : (
    <button className="p-2" style={{ zIndex: 20 }} onClick={() => setFullscreenOpen(true)}>
      <Expand role="button" width={size} height={size} color="#808080" />
    </button>
  );
};
